export default __webpack_public_path__ + "static/media/information--tourist-attraction--g1.9aad0dc2.png";